export const SCENE7_JS_URL = "https://kohler.scene7.com/s7viewers/html5/js/"
export const SCENE7_SERVER_IMAGE = "https://kohler.scene7.com/is/image/"
export const THREE_SIXTY_LABLE = "360 spin"
export const THREE_SIXTY_MAIN = "main"
export const THREE_SIXTY_CAROUSEL_LABLE = "carousel"
export const THREE_SIXTY_FULL_SCREEN = "360 spin fullscreen"
